import { UserService } from '@core/services/user/UserService';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

export function useIdCardUploader() {
    function uploadIdCard(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                try {
                    const response = await UserService.getInstance().uploadIdCard(reader.result as string, file.name);
                    AnalyticsSDK.getInstance().log('Additional_Document_Attempt');

                    resolve(response);
                } catch (e) {
                    AnalyticsSDK.getInstance().log('Additional_Document_Error');
                    reject(e);
                }
            };
        });
    }

    return {
        uploadIdCard,
    };
}
